import React, { useRef } from "react";
import "./resizer.styles.css";

/**
 * @param {Number} width: the width of the child component/block
 * @param {Number} height: the height of the child component/block
 * @param {Function} getSizeProps: the callback function that returns an object containing new height and width
 * @param {Object} children: the component to be resized
 * @returns
 */

const Resizer = ({
  width,
  height,
  getSizeProps,
  strokeWidth,
  children,
}) => {
  const resizeWrapperRef = useRef(null);

  //Window funtion mousemove & mouseup
  const initResize = (event) => {
    event.stopPropagation();
    window.addEventListener("mousemove", resize, false);
    window.addEventListener("mouseup", stopResize, false);
  };

  //resize the element
  const resize = (event) => {
    event.stopPropagation();
    const rect = resizeWrapperRef.current.getBoundingClientRect();
    const newWidth = event.clientX - rect.left;
    const newHeight = event.clientY - rect.top;
    getSizeProps({ newWidth, newHeight });
  };

  //on mouseup remove windows functions mousemove & mouseup
  const stopResize = (evt) => {
    window.removeEventListener("mousemove", resize, false);
    window.removeEventListener("mouseup", stopResize, false);
  };

  return (
    <div
      className="resizer__wrapper"
      ref={resizeWrapperRef}
      style={{ position: "relative", width, height }}
    >
      <div
        className={"resizer__handlerContainer"}
        style={{ width, height }}
      ></div>
      <div
        className={"resizer__handler--bottomRight"}
        onMouseDown={initResize}
      ></div>
      {children}
    </div>
  );
};

export default Resizer;
